import ic_facebook from './Recursos/ic_facebook.svg'
import ic_insta from './Recursos/ic_insta.svg'
import ic_tiktok from './Recursos/ic_tiktok.svg'
import ic_linke from './Recursos/ic_linke.svg'


export const SECCIONES = ['Tienda', 'Ofertas','Dropshipping', 'Partners' ]

export const REDES = [
    {
        nombre: 'facebook',
        img: ic_facebook,
        url: ''
    },
    {
        nombre: 'instagram',
        img: ic_insta,
        url: ''
    },
    {
        nombre: 'tiktok',
        img: ic_tiktok,
        url: ''
    },
    {
        nombre: 'linkedin',
        img: ic_linke,
        url: ''
    },
]